/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Sovereignty_AnswerInputs */

const en_landing_faq_sovereignty_answer = /** @type {(inputs: Landing_Faq_Sovereignty_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Your proprietary data never leaves your infrastructure. We do not host it, and we never use it to train public AI models. Inginuiti sits as a secure layer over your existing research, keeping your IP 100% private and sovereign.`)
};

/**
* | output |
* | --- |
* | "Yes. Your proprietary data never leaves your infrastructure. We do not host it, and we never use it to train public AI models. Inginuiti sits as a secure lay..." |
*
* @param {Landing_Faq_Sovereignty_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_sovereignty_answer = /** @type {((inputs?: Landing_Faq_Sovereignty_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Sovereignty_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_sovereignty_answer(inputs)
});